import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ApplicationTemplateEditCellRendererParams } from './models/application-template-edit-cell-renderer-params';
import { RouteConstants } from '../../../../../../core/constants/routes';

import { Router } from '@angular/router';
import { DirectEntryStepPaths } from '../../../../../../modules/application/direct-entry/shared/constants/direct-entry-steps';
import { ReturnRouteService } from '../../../../../../core/services/navigation/return-route.service';

@Component({
    selector: 'app-application-template-edit-cell-renderer',
    templateUrl: './application-template-edit-cell-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [],
})
export class ApplicationTemplateEditCellRendererComponent
    implements ICellRendererAngularComp
{
    params!: ApplicationTemplateEditCellRendererParams;

    constructor(
        private readonly router: Router,
        private readonly returnRouteService: ReturnRouteService,
    ) {}

    agInit(params: ApplicationTemplateEditCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }

    navigate(): void {
        this.returnRouteService.set(this.params.returnRoute ?? null);
        this.router.navigate([this.getRouterLink()]);
    }

    getRouterLink(): string {
        return RouteConstants.Application.getDirectEntryFullRouteWithApplicationId(
            DirectEntryStepPaths.generalInfo,
            this.params.data.templateApplicationMasterId.toString(),
        );
    }
}
